export default __webpack_public_path__ + "static/media/coffee-house.f64de3b3.png";